//**** REACT
import React, { useContext } from "react";
// *** Services

// *** Core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField/TextField";

// *** Contexto
import { UsuarioContext } from "config/context/UsuarioProvider";

import imgValidacionCedula from "assets/img/com-fes/img-validacion-cedula.png";
// *** @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import Button from "components/CustomButtons/Button";
import ImageUpload from "components/CustomUpload/ImageUpload.js";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import EnvioCI from "./EnvioCI";

//**** Estilos
import styles from "assets/jss/material-kit-pro-react/views/ecommerceSections/latestOffersStyle";
const useStyles = makeStyles(styles);


//const useStyles = makeStyles(basicsStyle);
const useStyles2 = makeStyles(featuresStyle);

export default function ValidacionCI() {
  const { usuario, setusuario, planUser } = useContext(UsuarioContext);
  const classes2 = useStyles2();
  const classes = useStyles();
  var numserieRef = React.createRef();
  ValidatorForm.addValidationRule("isTruthy", (value) => value);
  function Alert() {
    return "";
  }
  const onChange = (e) => {
    //e.preventDefault();
    // file is the file/image uploaded
    // in this function you can save the image (file) on form submit
    // you have to call it yourself
    convertBase64(e).then((response)=>{
      //console.log(response,'documento')
      setusuario({ ...usuario, b64: response })
    })

  };
  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        var doc = fileReader.result.split(",");
        resolve(doc[1]);
      }
      fileReader.onerror = (error) => {
        reject(error);
      }
    })
  }
  return (
    <div>
      {usuario.cienviado==true?
      <EnvioCI/>:null}
      <GridContainer>
        <GridItem xs={12} sm={12} md={6}>
          <div className={classes2.features3}>
            {planUser === "CFES" ? (
              <img src={imgValidacionCedula} alt="..." />
            ) : (
              <img src={imgValidacionCedula} alt="..." />
            )}
          </div>
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.title} style={{ textAlign: "center", marginTop: "50px", marginBottom: "0px" }}>
                <h2>No se pudo validar la cédula ingresada.</h2>
              </div>
              <div className={classes.title} style={{ textAlign: "justify" }}>
                <h4>
                  Agradeceremos enviar un email <strong>adjuntando su cédula de identidad vigente</strong> al correo soporte@firmadox.cl. Uno de nuestros ejecutivos se pondrá en contacto a la brevedad.
                </h4>
                <h4>
                  <ul>
                    <GridContainer>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ paddingTop: 10 }}
                      >
                        <TextField
                          fullWidth
                          id="txtRUT"
                          label="RUN"
                          value={usuario.rut}
                          disabled
                          onChange={(e) =>
                            setusuario({ ...usuario, rut: e.target.value })
                          }
                        />
                      </GridItem>
                      <GridItem
                        xs={12}
                        sm={12}
                        md={12}
                        lg={12}
                        style={{ paddingTop: 30 }}
                      >
                        <TextValidator
                          fullWidth
                          autoFocus
                          ref={numserieRef}
                          onBlur={(e) => numserieRef.current.validate(e.target.value)}
                          id="txtNoSerie"
                          label="No. de Serie"
                          value={usuario.numserie}
                          onChange={(e) =>
                            setusuario({ ...usuario, numserie: e.target.value })
                          }
                          validators={[
                            "minStringLength:9",
                            "maxStringLength:10",
                            "required",
                          ]}
                          errorMessages={[
                            "Campo requerido o mínimo 9 y máximo 10 caracteres",
                          ]}
                        />
                      </GridItem>
                    </GridContainer>
                  </ul>
                </h4>
              </div>
            </GridItem>

          </GridContainer>
        </GridItem>
      </GridContainer>
    </div>
  );
}
